import React from 'react';
import { Outlet } from 'react-router-dom';
import AppShell from './AppShell';

const Layout: React.FC = () => {
  return (
    <AppShell>
      <main className="text-white">
        <Outlet />
      </main>
    </AppShell>
  );
};

export default Layout;